"use client";

import Link from "next/link";
import VadImage from "vadimages-nextjs-image-optimizer";

const pdfDirectory = "/pdf/preffered-rate-sale/";

interface TariffBlockProps {
  title: string;
  buttonLabel: string;
  pdfName: string;
  imageName: string;
}

const TariffBlock = ({
  title,
  buttonLabel,
  pdfName,
  imageName,
}: TariffBlockProps) => (
  <div className="w-full">
    <div className="text-center w-full mb-7">
      <h5
        className="font-semibold mb-5"
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <Link href={`${pdfDirectory}${pdfName}`} target="_blank" className="mx-auto w-fit flex items-center justify-between gap-2.5 rounded-[4px] font-medium bg-golden-lemon px-4 py-3 duration-300 hover:bg-golden-lemon/80 mb-[30px]">
        <span>{buttonLabel}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="16"
          viewBox="0 0 18 16"
          fill="none"
        >
          <path
            d="M10.7368 0.742188L9.69079 1.78824L15.1184 7.21587H1V8.69614H15.2171L9.69079 14.2126L10.7368 15.2586L18 8.00535L10.7368 0.742188Z"
            fill="#414042"
          />
        </svg>
      </Link>
      <Link href={`${pdfDirectory}${pdfName}`} target="_blank">
        <VadImage
          src={`/images/black-friday/${imageName}`}
          alt={imageName}
          width={446}
          height={576}
          className="border-none mx-auto"
        />
      </Link>
    </div>
  </div>
);

export default TariffBlock;
// <Link href={`${pdfDirectory}${pdfName}`}>
